import { render, staticRenderFns } from "./IOpen.vue?vue&type=template&id=f5fa27c4&"
import script from "./IOpen.vue?vue&type=script&lang=ts&"
export * from "./IOpen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports